export enum RoasCpoViewType {
  ROAS = 'ROAS',
  CPO = 'CPO'
}
